import { useStore } from 'vuex';

export default function useMixpanel() {
  const store = useStore();
  const mixpanel = store.$app.config.globalProperties.mixpanel;

  return {
    ...mixpanel,
    track: (event, data) => mixpanel.track(event, data)
  };
}
